<template>
  <div class="photo-consultation-list-container">
    <h1 class="page-title">旅拍咨询列表</h1>
    <el-card class="content-card">
      <div class="card-header">
        <h2>旅拍咨询列表</h2>
      </div>
      <div class="card-content">
        <!-- 搜索筛选区域 -->
        <div class="search-filter-section">
          <el-form :inline="true" :model="searchForm" size="small">
            <el-form-item label="搜索">
              <el-input v-model="searchForm.search" placeholder="请输入姓名、电话或备注" clearable />
            </el-form-item>
            <el-form-item label="跟进状态">
              <el-select v-model="searchForm.follow_up_status" placeholder="请选择跟进状态" clearable>
                <el-option label="待跟进" :value="0" />
                <el-option label="已跟进" :value="1" />
                <el-option label="已完成" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="() => { consultations.current_page = 1; fetchData(); }">搜索</el-button>
              <el-button @click="() => { searchForm.search = ''; searchForm.follow_up_status = ''; consultations.current_page = 1; fetchData(); }">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 数据表格区域 -->
        <div class="table-section">
          <el-table v-loading="loading" :data="consultations.data" style="width: 100%" border>
            <el-table-column prop="id" label="ID" width="80" align="center" />
            <el-table-column prop="name" label="姓名" width="120" />
            <el-table-column prop="phone" label="电话" width="150" />
            <el-table-column prop="package.title" label="咨询套餐" min-width="180">
              <template #default="scope">
                {{ scope.row.package?.title || '未选择套餐' }}
              </template>
            </el-table-column>
            <el-table-column prop="follow_up_status" label="跟进状态" width="120" align="center">
              <template #default="scope">
                <el-tag :type="(scope.row.follow_up_status === 0 ? 'warning' : (scope.row.follow_up_status === 1 ? 'info' : 'success'))">
                  {{ (scope.row.follow_up_status === 0 ? '待跟进' : (scope.row.follow_up_status === 1 ? '已跟进' : (scope.row.follow_up_status === 2 ? '已完成' : '未知状态'))) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remarks" label="备注" min-width="200" show-overflow-tooltip />
            <el-table-column prop="created_at" label="咨询时间" width="180" align="center" />
            <el-table-column label="操作" width="200" align="center" fixed="right">
              <template #default="scope">
                <el-button size="small" type="primary" @click="() => { ElMessage.info(`编辑咨询 ID: ${scope.row.id}`); }">
                  编辑
                </el-button>
                <el-button size="small" type="danger" @click="() => { ElMessage.info(`删除咨询 ID: ${scope.row.id}`); }">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页区域 -->
          <div class="pagination-section">
            <el-pagination
              :current-page="consultations.current_page"
              :page-size="consultations.per_page"
              :page-sizes="[10, 20, 50, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="consultations.total"
              @size-change="(size) => { consultations.current_page = 1; consultations.per_page = size; fetchData(); }"
              @current-change="(current) => { consultations.current_page = current; fetchData(); }"
            />
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { getPhotoConsultations } from '@/api/photo';
import { ElMessage } from 'element-plus';

// 状态管理
const loading = ref(false);
const consultations = ref({
  data: [],
  total: 0,
  current_page: 1,
  per_page: 10
});

// 搜索表单
const searchForm = ref({
  search: '',
  follow_up_status: ''
});

// 获取数据
const fetchData = async () => {
  loading.value = true;
  try {
    const params = {
      page: consultations.value.current_page,
      per_page: consultations.value.per_page,
      search: searchForm.value.search,
      follow_up_status: searchForm.value.follow_up_status || undefined
    };
    const response = await getPhotoConsultations(params);
    consultations.value = response.data;
  } catch (error) {
    console.error('获取旅拍咨询列表失败:', error);
    ElMessage.error('获取旅拍咨询列表失败');
  } finally {
    loading.value = false;
  }
};

// 页面挂载时获取数据
onMounted(() => {
  fetchData();
});
</script>

<style scoped>
.photo-consultation-list-container {
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.content-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.card-content {
  padding: 20px 0;
}

.search-filter-section {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.table-section {
  margin-top: 20px;
}

.pagination-section {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>